import { getAction, deleteAction, putAction, postAction, httpAction } from './manage'

const queryPermissionsByUser = params => getAction('/sys/permission/getUserPermissionByToken', params)

export { queryPermissionsByUser }
